export const ADMIN_TEAM_CALENDARS_ANALYTICS_SOURCE = 'adminTeamCalendars';
